import {
  Users,
  CalendarCheck,
  Wallet,
  Dumbbell,
  Send,
  PartyPopper,
  Tag,
  Bell,
  Activity,
  Gift,
  LucideIcon,
} from "lucide-react";

export type AdminSectionKey =
  | "users"
  | "bookings"
  | "payouts"
  | "gyms"
  | "invites"
  | "events"
  | "discounts"
  | "notifications"
  | "usage"
  | "referrals";

export interface AdminSectionDef {
  key: AdminSectionKey;
  label: string;
  subtitle: string;
  icon: LucideIcon;
}

export const ADMIN_SECTIONS: AdminSectionDef[] = [
  { key: "users", label: "Users", subtitle: "Members, memberships and account fixes", icon: Users },
  { key: "usage", label: "App Usage", subtitle: "How members and visitors use the app", icon: Activity },
  { key: "bookings", label: "Class Bookings", subtitle: "Regular bookings and class drops over time", icon: CalendarCheck },
  { key: "referrals", label: "Referrals", subtitle: "Referrals shared and users who joined", icon: Gift },
  { key: "payouts", label: "Payout Reports", subtitle: "What each studio is owed for a period", icon: Wallet },
  { key: "gyms", label: "Gyms", subtitle: "Visibility, integrations and owners", icon: Dumbbell },
  { key: "invites", label: "Partner Invites", subtitle: "Send onboarding links to new partners", icon: Send },
  { key: "events", label: "Events", subtitle: "Social events shown in the app", icon: PartyPopper },
  { key: "discounts", label: "Discount Codes", subtitle: "Promo codes synced to Stripe", icon: Tag },
  { key: "notifications", label: "Notifications", subtitle: "Email and push broadcasts", icon: Bell },
];
